export const getKeyboardNavigationDirection = (key) => {
  if (key === 'Enter') return 'right'
  if (key === 'Control') return 'left'
  if (key === 'F1') return 'down'
  return null
}

export const createTableInputResolver = (input) => {
  if (!input) return () => null

  const table = input.closest('.rp-table')
  const row = input.closest('tr')
  const cell = input.closest('td, th')
  if (!table || !row || !cell) {
    return () => (input.isConnected ? input : null)
  }

  const rowIndex = Array.from(table.querySelectorAll('tr')).indexOf(row)
  const cellIndex = Array.from(row.cells).indexOf(cell)
  const inputIndex = Array.from(cell.querySelectorAll('input')).indexOf(input)

  if (rowIndex < 0 || cellIndex < 0 || inputIndex < 0) {
    return () => (input.isConnected ? input : null)
  }

  return () => {
    if (input.isConnected) return input
    if (!table.isConnected) return null

    const currentRow = table.querySelectorAll('tr')[rowIndex]
    const currentCell = currentRow?.cells[cellIndex]
    return currentCell?.querySelectorAll('input')[inputIndex] ?? null
  }
}
